// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__38v7Y","text":"Landing_text__KAeM5","link":"Landing_link__izleQ"};